const maskEmail = (email, character = '*') => {
  const partitionEmail = email.split('@');
  const partitionLeft = partitionEmail[0]?.replace(/[a-z0-9@.-_](?=[a-z0-9@.-_]{4})/g, character);
  const resolveEmail = `${partitionLeft}@${partitionEmail[1]}`.trim();
  return resolveEmail;
};

const resolveMonth = (numberMonth) => {
  let nameMonth = '';
  switch (numberMonth) {
    case '01':
      nameMonth = 'Enero';
      break;
    case '02':
      nameMonth = 'Febrero';
      break;
    case '03':
      nameMonth = 'Marzo';
      break;
    case '04':
      nameMonth = 'Abril';
      break;
    case '05':
      nameMonth = 'Mayo';
      break;
    case '06':
      nameMonth = 'Junio';
      break;
    case '07':
      nameMonth = 'Julio';
      break;
    case '08':
      nameMonth = 'Agosto';
      break;
    case '09':
      nameMonth = 'Septiembre';
      break;
    case '10':
      nameMonth = 'Octubre';
      break;
    case '11':
      nameMonth = 'Noviembre';
      break;
    case '12':
      nameMonth = 'Diciembre';
      break;
    default:
      nameMonth = '';
      break;
  }
  return nameMonth;
};

const monthToNumber = (month) => {
  let numberMonth = '';
  switch (month) {
    case 'Enero':
      numberMonth = '01';
      break;
    case 'Febrero':
      numberMonth = '02';
      break;
    case 'Marzo':
      numberMonth = '03';
      break;
    case 'Abril':
      numberMonth = '04';
      break;
    case 'Mayo':
      numberMonth = '05';
      break;
    case 'Junio':
      numberMonth = '06';
      break;
    case 'Julio':
      numberMonth = '07';
      break;
    case 'Agosto':
      numberMonth = '08';
      break;
    case 'Septiembre':
      numberMonth = '09';
      break;
    case 'Octubre':
      numberMonth = '10';
      break;
    case 'Noviembre':
      numberMonth = '11';
      break;
    case 'Diciembre':
      numberMonth = '12';
      break;
    default:
      numberMonth = '0';
      break;
  }
  return numberMonth;
};

export default { maskEmail, resolveMonth, monthToNumber };
